export default __webpack_public_path__ + "static/media/meals.7ea3bde3.jpg";